import script from "./HrSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./HrSpace.vue?vue&type=script&setup=true&lang=js"

import "./HrSpace.vue?vue&type=style&index=0&id=1640ab98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1640ab98"]])

export default __exports__